<div class="mb-5">
  <h1 i18n>Group Administration</h1>
  <p class="note py-0 my-0" i18n>Search for a group by name or description using the search bar below (enter 3 character or more
    to search).</p>
  <div>
    <div class="d-flex flex-column flex-md-row w-100 gap-3 m-0 col-12 lg:col-8 xl:col-6 pl-0 pr-3 lg:pr-0">
      <p-inputgroup class="flex-grow-1">
        <p-inputgroup-addon><i class="pi pi-search"></i></p-inputgroup-addon>
        <input pInputText
               type="text"
               (input)="search($event)"
               placeholder="Find by Name or Description"/>
        <button type="button"
                class="p-button flex-shrink-0 merge-left"
                aria-label="Add new group"
                (click)="createGroup()"
                (keydown.enter)="createGroup()" i18n>
          Create Group
        </button>
      </p-inputgroup>
    </div>
    <div class="group-management mx-auto col-12 pl-0 pr-3">
      <p-table
        aria-label="Group Table"
        [value]="groups"
        [paginator]="false"
        [loading]="loading"
        [responsiveLayout]="'stack'"
        [scrollable]="false"
        scrollHeight="flex"
        styleClass="p-datatable-striped"
        [showInitialSortBadge]="true"
        [customSort]="true"
        (sortFunction)="sortBy($event)">
        <ng-template pTemplate="header">
          <tr>
            <th id="groupId" pSortableColumn="groupId">ID
              <p-sortIcon field="groupId"/>
            </th>
            <th id="name" pSortableColumn="name">Name
              <p-sortIcon field="name"/>
            </th>
            <th id="active" class="w-1rem"></th>
            <th id="edit" class="w-1rem"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-group>
          <tr [pTooltip]="group.description || ''" role="row">
            <td aria-labelledby="Group ID">{{ group.groupId }}</td>
            <td aria-labelledby="Group Name">{{ group.displayName }}</td>
            <td class="w-1rem" i18n-aria-label aria-label="Active or Locked">
              <i class="pi {{ group.locked ? 'pi-lock' : 'pi-lock-open' }}"></i>
            </td>
            <td class="flex edit-cog" aria-labelledby="edit">
              <button class="edit-btn p-button-text p-button-icon-only" pButton type="button"
                      (click)="editGroup(group.groupId)">
                <i class="pi pi-cog"></i>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" i18n aria-live="polite">No Groups found</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex-auto">
      <p-paginator (onPageChange)="changePage($event)"
                   [first]="firstRecord"
                   [rows]="pageSize"
                   [totalRecords]="totalRecords"
                   [rowsPerPageOptions]="[3, 25, 50, 100]"></p-paginator>
    </div>
  </div>
</div>

